// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._2XDOYYwb6pq6GPnx3WtWk1 {\n    display: flex;\n    justify-content: center;\n}\n\n.chcw9qEq5E_7KIWKNXDvV {\n    list-style-type: none;\n}", "",{"version":3,"sources":["webpack://./src/components/pages/search/styles/PlantList.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;AACzB","sourcesContent":[".loading {\n    display: flex;\n    justify-content: center;\n}\n\n.PlantList {\n    list-style-type: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loading": "_2XDOYYwb6pq6GPnx3WtWk1",
	"PlantList": "chcw9qEq5E_7KIWKNXDvV"
};
export default ___CSS_LOADER_EXPORT___;
